import Vue from 'vue'
import createAppClient from './commons/createAppClient'

let host
if (location.hostname === 'localhost') {
  host = 'http://localhost:3200'
  // host = 'http://47.94.156.98:3300'
} else if (location.hostname === '127.0.0.1') {
  host = 'http://47.94.156.98:3300'
} else {
  host = location.origin
}

const app = createAppClient(host)
window.app = app
Vue.prototype.$app = app

export default app
